import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import snackbarPlugin from './plugins/snackbar'
import loadingStatePlugin from './plugins/loadingState'
import 'quill/dist/quill.snow.css'
import { CognitoAuthPlugin } from '@/cognito/cognito'
import { VOffline } from 'v-offline'
import subscriptionClient from '@/graphql/subscriptionClient'
import cognitoAuth from '@/cognito'
import errorReporter from '@/utils/errorReporter'

errorReporter.init({
  version: process.env.VUE_APP_VERSION
})

window.addEventListener('error', (event) => {
  errorReporter.reportError({
    message: event.message || 'Unknown error',
    stack: event.error?.stack || `at ${event.filename}:${event.lineno}:${event.colno}`,
    type: 'uncaught-exception',
    extra: { source: event.filename, lineno: event.lineno, colno: event.colno }
  })
})

window.addEventListener('unhandledrejection', (event) => {
  const error = event?.reason
  errorReporter.reportError({
    message: error?.message || String(error) || 'Unhandled promise rejection',
    stack: error?.stack || '',
    type: 'unhandled-rejection'
  })
})

// Initialize subscription client
subscriptionClient.init({
  endpoint: process.env.VUE_APP_APPSYNC_GRAPHQL_ENDPOINT,
  region: process.env.VUE_APP_APPSYNC_REGION,
  auth: {
    type: process.env.VUE_APP_APPSYNC_AUTHENTICATION_TYPE,
    jwtToken: () => cognitoAuth.getIdTokenPromise()
  }
})

const app = createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .use(CognitoAuthPlugin)
  .use(snackbarPlugin, { store })
  .use(loadingStatePlugin, { store })
  .component('VOffline', VOffline)

app.config.errorHandler = (err, instance, info) => {
  console.error('Vue error:', err)
  errorReporter.reportError({
    message: err?.message || String(err),
    stack: err?.stack || '',
    type: 'vue-error',
    extra: { info, componentName: instance?.$options?.name || instance?.$.type?.name || 'Unknown' }
  })
}

const vm = app.mount('#app')

// Client telemetry — capture client-side failures (generation failures, network
// drops, GraphQL errors, logouts) server-side. Best-effort; never blocks startup.
import('@/utils/telemetry').then(({ initTelemetry }) => initTelemetry()).catch(() => {})

if (window.Cypress) {
  window.store = store
}

export default vm
